import {PedidoItem} from "../pedido-item";

export class DemandaCmd {
    id: number = -1;
    forca: string = "";
    unidade: string = "";
    telefone: string = "";
    objeto: string = "";
    justificativa: string = "";
    items: PedidoItem[] = new Array<PedidoItem>();
    resultado: string = "";
    delegaciaId: number = -1;
}
